export const uploadMedia = (event?: any, onFinish?: any) => {
  const file = event.target.files[0]
  const reader = new FileReader()

  reader.onloadend = () => {
    onFinish(file)
  }

  reader.readAsDataURL(file)
}
export const openCamera = (onFinish?: any) => {
  // DO NOT REMOVE THIS FUNCTION !!!!!
  // Prevent the screen from using native library causing the app to crash
}
